import IPage from "../../../interfaces/page";
import SelectProductComponent from "../../Components/SelectProduct/SelectProduct.component";
import MainLayout from "../../layouts/Main/Main.layout";

const SelectProductPage: React.FC<IPage> = () => {
    return <MainLayout component={SelectProductComponent}></MainLayout>
}

export default SelectProductPage;